import { cn } from "@/lib/utils";

export default function MobileShell({ children, hideNav = false, contentClassName = "" }) {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className={cn("mx-auto max-w-md min-h-screen bg-slate-50 relative pb-24", contentClassName)}>
        {children}
      </div>
    </div>
  );
}
